import { render } from "./PersonalizationView.vue?vue&type=template&id=151b2f66&scoped=true"
import script from "./PersonalizationView.vue?vue&type=script&lang=js"
export * from "./PersonalizationView.vue?vue&type=script&lang=js"

import "./PersonalizationView.vue?vue&type=style&index=0&id=151b2f66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151b2f66"]])

export default __exports__